import React from "react";
import { Box, Tooltip } from "@chakra-ui/react";
import { PALETTES } from "../classroomColors";
import { STANDE } from "../standeTokens";

/**
 * One tool in the bar (Figma 222:296): a 36px pill that inverts to
 * stande-black when it is the active tool.
 *
 * The icon is rendered inline rather than through an <img>, so its strokes
 * are `currentColor` and follow the button between idle, hover and active.
 * The previous version tinted a flat image with a CSS invert filter, which
 * turned #222 into #ddd instead of the cream the design asks for and could
 * not respond to hover at all.
 *
 * Presentational only — it is told whether it is active and what to call, so
 * the bar owns tool state and this stays trivially reusable.
 */
const ToolButton = ({
  icon: Icon,
  label,
  shortcut,
  isActive = false,
  isDark = false,
  onClick,
  size = "36px",
  iconSize = "22px",
  ...rest
}) => {
  const p = isDark ? PALETTES.dark : PALETTES.light;
  const activeBg = isDark ? p.text : STANDE.black;
  const activeInk = isDark ? p.surface : STANDE.cream;

  return (
    <Tooltip
      label={shortcut ? `${label}  ${shortcut.toUpperCase()}` : label}
      placement="left"
      hasArrow
      openDelay={350}
      fontSize="11px"
    >
      <Box
        as="button"
        type="button"
        aria-label={label}
        aria-pressed={isActive}
        onClick={onClick}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        boxSize={size}
        borderRadius="full"
        bg={isActive ? activeBg : p.surfaceSubtle}
        color={isActive ? activeInk : p.text}
        transition="background 0.15s, color 0.15s"
        _hover={isActive ? {} : { bg: p.hover, color: p.text }}
        _focusVisible={{ outline: "2px solid", outlineColor: p.text, outlineOffset: "2px" }}
        {...rest}
      >
        <Icon width={iconSize} height={iconSize} aria-hidden focusable="false" />
      </Box>
    </Tooltip>
  );
};

export default ToolButton;
